import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScheduleLibraryFolders = api(async function scheduleLibraryFoldersForRules() {
    return query(
        gql`
            query GetScheduleLibraryFoldersForRules {
                scheduleLibraryFoldersForRules {
                    id
                    name
                    path
                    library
                    parentId
                }
            }
        `,
        {},
        { returns: "scheduleLibraryFoldersForRules" }
    )
})
